import ACTION_TYPES from '../actions/actionTypes';

export default function crossSliceReducer(state, action) {
  if (!action) return state;

  // eslint-disable-next-line default-case
  switch (action.type) {
    case ACTION_TYPES.PROFILE_UPDATE_CARD_COMPLETED:
      return updatePagesFromCards(state, action);
  }

  return state;
}

var findCardInPages = (pages, cardName) => {
  for (var pName in pages) {
    var cardsArr = pages[pName].cards;
    if (cardsArr && cardsArr.indexOf(cardName) > -1) return pName;
  }
  return null;
};

var updateStatus = state => {
  const barProps = [];
  for (var p in state.pages) {
    barProps.push({
      stepLabel: state.pages[p].pageLabel,
      completed: state.pages[p].completed,
    });
  }
  return barProps;
};

//need the card stage.
const updatePage = (card, page) => {
  var cardsInPage = page.cards.map(c => card.cards[c]);
  // page is completed only if all cards are completed.
  page.completed = !cardsInPage.some(e => {
    //check if some of them have false completed statue.
    return !(e.completed === true);
  });
};

export function updatePagesFromCards(state, resp) {
  const { type, currentCard } = resp.value;
  const { page, card } = state;
  const pages = {
    ...page.pages,
  };
  if (!page || (page && page.showAllPage)) {
    //update all pages.
    for (var pName in page.pages) {
      updatePage(card, pages[pName]);
    }
  } else {
    var pageName = findCardInPages(page.pages, currentCard);
    if (!pageName) return state;
    var cardPage = pages[pageName];
    updatePage(card, cardPage);
  }
  return {
    ...state,
    page: {
      ...page,
      progressBarProps: {
        showCompletedIcon: page.showCompletedIcon,
        steps: updateStatus(page),
      },
    },
  };
}
